import type { Dayjs } from 'dayjs';
import type { ConfirmEdoReceiptBody } from '../types';
import { isCommentRequired } from './commentPolicy';
import {
  validateTaskModalEventDate,
  validateTaskModalRequiredComment,
} from './taskModalValidation';

export type EdoReceiptResult = 'RECEIVED' | 'RESEND' | 'REVISION';

export type ConfirmEdoReceiptValidationIssue = {
  code: 'EVENT_DATE_REQUIRED' | 'COMMENT_REQUIRED' | 'RESULT_REQUIRED';
  message: string;
};

export function validateConfirmEdoReceiptSubmit(input: {
  result: EdoReceiptResult | null | undefined;
  eventAt: Dayjs | null | undefined;
  comment: string | null | undefined;
}): ConfirmEdoReceiptValidationIssue | null {
  if (input.result !== 'RECEIVED' && input.result !== 'RESEND' && input.result !== 'REVISION') {
    return { code: 'RESULT_REQUIRED', message: 'Выберите результат проверки ЭДО' };
  }

  const dateIssue = validateTaskModalEventDate(
    input.eventAt,
    input.result === 'RESEND' || input.result === 'REVISION'
      ? 'Укажите дату проверки'
      : 'Укажите дату подтверждения'
  ) as ConfirmEdoReceiptValidationIssue | null;
  if (dateIssue) return dateIssue;

  if (input.result === 'RECEIVED') {
    return null;
  }

  return validateTaskModalRequiredComment(
    input.comment,
    input.result === 'REVISION' ? 'Укажите причину доработки' : 'Укажите комментарий'
  ) as ConfirmEdoReceiptValidationIssue | null;
}

export function buildEdoReceiptBody(input: {
  result: EdoReceiptResult;
  comment: string;
  receivedAt: string;
}): ConfirmEdoReceiptBody {
  const body: ConfirmEdoReceiptBody = {
    result: input.result,
    receivedAt: input.receivedAt,
  };

  const trimmedComment = input.comment.trim();
  if (trimmedComment.length > 0) {
    body.comment = trimmedComment;
  }

  return body;
}

export function getEdoReceiptSubmitLabel(result: EdoReceiptResult): string {
  if (result === 'RESEND') {
    return 'Повторить отправку через ЭДО';
  }
  if (result === 'REVISION') {
    return 'Запросить исправление комплекта';
  }
  return 'Подтвердить принятие в ЭДО';
}

export function getEdoReceiptSuccessMessage(result: EdoReceiptResult): string {
  if (result === 'RESEND') {
    return 'Повторная отправка через ЭДО доступна';
  }
  if (result === 'REVISION') {
    return 'Запрошено исправление комплекта по ЭДО';
  }
  return 'Принятие документов по ЭДО подтверждено';
}

export function isEdoReceiptCommentRequired(result: EdoReceiptResult): boolean {
  return isCommentRequired(result);
}

export function getEdoReceiptCommentLabel(result: EdoReceiptResult): string {
  return result === 'REVISION' ? 'Причина доработки' : 'Комментарий';
}
